import React, { useState } from 'react'
import { Col, Input, message, Modal, Row, Space } from 'antd'
import _ from 'lodash'
import { ButtonEx, SelectItem } from '../../../shared.style'
import { useDeepEffect } from '../../../utils/hooks'
import axios from 'axios'
import { RESPONSE_MESSAGE } from '../../../utils/constants'

const AddMaterial = (props) => {
  const { setPage, formData, products, heroType } = props
  const [stateList, setStateList] = useState([])
  const [productIdList, setProductIdList] = useState([])
  const [typeId, setTypeId] = useState([])

  useDeepEffect(() => {
    setStateList((prevState) => {
      products.forEach((category) => {
        prevState.push({
          categoryId: category.categoryId,
          categoryName: category.categoryName,
          materials: category.materialList
        })
      })
      return [...prevState]
    })
  }, [products])

  const onBack = () => {
    setPage('2')
  }

  function onSearch(value) {
    if (value) {
      products.forEach((category) => {
        setStateList((prevState) => {
          prevState.forEach((item) => {
            if (category.categoryId === item.categoryId) {
              const arr = _.filter(category.materialList, (material) => {
                return material.name.includes(value)
              })
              item.materials = arr
            }
          })

          return [...prevState]
        })
      })
    } else {
      setStateList((prevState) => {
        products.forEach((category) => {
          prevState.forEach((item) => {
            if (category.categoryId === item.categoryId) {
              item.materials = category.materialList
            }
          })
        })

        return [...prevState]
      })
    }
  }

  const renderActiveAll = () => {
    let active = false

    if (typeId.length === products.length) {
      active = true
    }

    return active
  }

  const renderCategoryActive = (id) => {
    let active = false

    typeId.forEach((item) => {
      if (item === id) {
        active = true
      }
    })

    return active
  }

  const onClickAll = () => {
    if (typeId.length !== products.length) {
      const typeIds = products.map((item) => item.categoryId)
      setTypeId(typeIds)

      setProductIdList((prevState) => {
        prevState = []
        products.forEach((category) => {
          category.materialList.forEach((item) => {
            if (item.baseMaterial) {
              prevState.push(item)
            }
          })
        })
        return [...prevState]
      })
    } else {
      setTypeId([])
      setProductIdList([])
    }
  }

  const onClickCategory = (category) => {
    const findId = _.some(typeId, (item) => {
      return item === category.categoryId
    })

    if (findId) {
      const arr = _.remove(typeId, (item) => {
        return item !== category.categoryId
      })
      setTypeId(arr)

      setProductIdList((prevState) => {
        category.materials.forEach((material) => {
          _.remove(prevState, (item) => {
            return item.id === material.id
          })
        })
        return [...prevState]
      })
    } else {
      setTypeId((prevState) => {
        prevState.push(category.categoryId)
        return [...prevState]
      })

      setProductIdList((prevState) => {
        category.materials.forEach((item) => {
          if (item.baseMaterial) {
            prevState.push(item)
          }
        })
        return [...prevState]
      })
    }
  }

  const renderItemActive = (item) => {
    let active = false

    if (!_.isEmpty(productIdList)) {
      active = productIdList.some((product) => {
        return product.id === item.id
      })
    }

    return active
  }

  function onClickItem(material) {
    const added = _.some(productIdList, (item) => {
      return item.id === material.id
    })

    if (added) {
      setProductIdList((prevState) => {
        const arr = prevState.filter((item) => item.id !== material.id)
        return [...arr]
      })
    } else {
      setProductIdList((prevState) => {
        prevState.push(material)
        return [...prevState]
      })
    }
  }

  async function onSave() {
    const data = {
      hero: {
        email: formData.email,
        heroName: formData.name,
        heroType: heroType,
        lineId: formData.lineId,
        password: formData.password,
        province: formData.province,
        tel: formData.tel,
        plateLicense: formData.plateLicense,
        purpose: formData.purpose,
        postalAddress: formData.postalAddress
      },
      location: {
        address: formData.address,
        id: 0,
        lat: formData.lat,
        lng: formData.lng,
        radius: formData.radius
      },
      heroMaterialRequests: productIdList.map((item) => {
        return {
          heroId: 0,
          materialId: item.id,
          minQuantity: 'NO_LIMIT',
          price: 0
        }
      })
    }

    try {
      const token = localStorage.getItem('user-token')
      await axios.post(
        process.env.REACT_APP_API_ENDPOINT + `/hero/create`,
        data,
        {
          headers: {
            Authorization: !_.isNull(token) ? `${token}` : ''
          }
        }
      )
      message.success(RESPONSE_MESSAGE.SUCCESS)
      setPage('4')
    } catch (err) {
      const { response } = err
      const { data } = response
      Modal.error({
        content: `${data.message}`
      })
    }
  }

  return (
    <div>
      <div style={{ marginTop: 10, height: 600, overflowY: 'scroll' }}>
        <Row gutter={[8, 8]}>
          <Col span={24}>
            <Row gutter={[8, 8]}>
              <Col span={24}>
                <span style={{ fontSize: 20, color: '#6ebf4b' }}>
                  เลือกวัสดุรีไซเคิลที่รับ
                </span>
              </Col>
              <Col span={24}>
                <Row gutter={8}>
                  <Col span={8}>
                    <Input.Search
                      allowClear
                      placeholder="ค้นหา"
                      onSearch={onSearch}
                    />
                  </Col>
                  <Col span={8}>
                    <Row align="middle">
                      <span>วัสดุที่คุณเลือก 0 รายการ</span>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={16} justify="center">
              <SelectItem
                onClick={() => onClickAll()}
                active={renderActiveAll()}>
                ทั้งหมด
              </SelectItem>
              {!_.isEmpty(stateList) &&
                stateList.map((item, index) => {
                  return (
                    <SelectItem
                      key={index}
                      onClick={() => onClickCategory(item)}
                      active={renderCategoryActive(item.categoryId)}>
                      {item.categoryName
                        .toString()
                        .substring(4, item.categoryName.toString().length)}
                    </SelectItem>
                  )
                })}
            </Row>
          </Col>
        </Row>
        {!_.isEmpty(stateList) &&
          stateList.map((item, index) => {
            return (
              <Row key={index} style={{ marginTop: 10 }}>
                {item.materials.map((material, idx) => {
                  return (
                    <SelectItem
                      key={idx}
                      active={renderItemActive(material)}
                      onClick={() => onClickItem(material)}>
                      {material.name}
                    </SelectItem>
                  )
                })}
              </Row>
            )
          })}
      </div>
      <Row justify="center" style={{ marginTop: 15 }}>
        <Space>
          <ButtonEx color="#707070" type="primary" onClick={() => onBack()}>
            ย้อนกลับ
          </ButtonEx>
          <ButtonEx color="#6ebf4b" type="primary" onClick={() => onSave()}>
            บันทึกข้อมูล
          </ButtonEx>
        </Space>
      </Row>
    </div>
  )
}

export default AddMaterial



// WEBPACK FOOTER //
// ./src/pages/Signup/AddMaterial/index.js